import React from 'react';
import PropTypes from 'prop-types';
import get from '../helpers/get';

class BrazeBanner extends React.Component {
  state = { banner: undefined };

  containerRef = React.createRef();

  hasSubscribed = false;

  inserted = false;

  componentDidMount() {
    global.window.addEventListener('appboyReady', this.onAppboyReady);
    this.onAppboyReady();
  }

  componentDidUpdate() {
    this.insertIfReady();
  }

  componentWillUnmount() {
    const { braze } = global.window;

    global.window.removeEventListener('appboyReady', this.onAppboyReady);
    if (braze && typeof braze.removeSubscription === 'function' && this.subscriptionId) {
      braze.removeSubscription(this.subscriptionId);
    }
  }

  getPlacementId = () => get(this.props.content, ['placement_id']);

  onAppboyReady = () => {
    const { braze } = global.window;

    if (!braze
      || typeof braze.subscribeToBannersUpdates !== 'function'
      || typeof braze.getBanner !== 'function'
      || this.hasSubscribed
      || !this.getPlacementId()) {
      return;
    }

    this.hasSubscribed = true;
    global.window.removeEventListener('appboyReady', this.onAppboyReady);
    this.subscriptionId = braze.subscribeToBannersUpdates(this.handleBannersUpdate);
  };

  handleBannersUpdate = () => {
    const { braze } = global.window;
    const banner = braze.getBanner(this.getPlacementId());

    if (!banner || (!banner.id && !banner.isControl)) {
      return;
    }

    this.setState({ banner });
  };

  insertIfReady = () => {
    const { banner } = this.state;
    const { braze } = global.window;
    const node = this.containerRef.current;

    if (braze && typeof braze.insertBanner === 'function' && banner && node && !this.inserted) {
      braze.insertBanner(banner, node);
      this.inserted = true;
    }
  };

  render() {
    const { banner } = this.state;

    if (!banner) {
      return null;
    }

    const { className } = this.props;
    const containerClassName = ['braze-banner-placeholder', className].filter(Boolean).join(' ');
    return (
      <div
        className={containerClassName}
        data-braze-placement={this.getPlacementId()}
        ref={this.containerRef}
        style={banner.isControl ? { display: 'none' } : undefined}
      />
    );
  }
}

BrazeBanner.propTypes = {
  className: PropTypes.string,
  content: PropTypes.objectOf(PropTypes.any),
};

BrazeBanner.defaultProps = {
  className: undefined,
  content: undefined,
};

export default BrazeBanner;
